import { DownloadDataButton } from './components/DownloadDataButton.js';
import { useBehavioralTrackingProps as _useBehavioralTrackingProps } from '../../../../core/hooks/useBehavioralTrackingProps.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { A11yToolbarTabIndex } from '../../../core/types/toolbar.js';
import { usePieChartRawData } from '../../context/PieChartRawDataContext.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useOverlayState } from '../../hooks/store/selectors.js';
import { zIndicesPieAreas } from '../../types/default.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

const defaultToolbarPlacement = 'top-right';

export const PieChartToolbar = () => {
  const dispatch = useTooltipReducer();
  const toolbarConfig = useToolbarConfig();
  const toolbarPlacement = toolbarConfig?.placement ?? defaultToolbarPlacement;
  const { mouseInBounds } = useOverlayState();

  const isDownloadEnabled = toolbarConfig?.downloadData?.enabled ?? false;
  const rawData = usePieChartRawData();

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => buildAndDownloadCsv(rawData);

  const showDefaultToolbarDownloadButton =
    isDownloadEnabled && !toolbarConfig?.intents;
  const showMenuToolbarButton =
    isDownloadEnabled && !!toolbarConfig?.intents?.length;

  const initialA11yState: A11yToolbarTabIndex[] =
    showDefaultToolbarDownloadButton ? [{ download: 0 }] : [{ intent: 0 }];

  const behaviorTrackingProps = _useBehavioralTrackingProps(
    toolbarConfig ?? {},
  )[0];

  return (
    <ChartToolbarRenderer
      visible={mouseInBounds}
      placement={toolbarPlacement}
      collapsed={toolbarConfig?.collapsed}
      draggable={true}
      zIndex={zIndicesPieAreas.toolbar}
      initialA11yState={initialA11yState}
      onMouseEnter={dispatch({ type: 'RESET_TOOLTIP' })}
      menuDisplayMode="never"
      isDownloadEnabled={showMenuToolbarButton}
      intents={toolbarConfig?.intents}
      handleDownloadDataToolbar={handleDownloadDataToolbar}
      removeDragHandle={true}
      {...behaviorTrackingProps}
    >
      {showDefaultToolbarDownloadButton && <DownloadDataButton />}
    </ChartToolbarRenderer>
  );
};
